// /* override functions api.jquery.js */
// Shopify.onItemAdded = function(line_item) {
//   Shopify.getCart();
// };

// Shopify.onCartUpdate = function(cart) {
//   Shopify.cartUpdateInfo(cart, '.cart-item-loop');
// };

// Shopify.onError = function(XMLHttpRequest, textStatus) {
//   var data = eval('(' + XMLHttpRequest.responseText + ')');
//   if (!!data.message) {
//     var str = data.description;
//   } else {
//    	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
//   }
//   jQuery('.error_message').text(str);
//   jQuery('#modalAddToCartError').modal("toggle");
//   setTimeout(function () {
//     jQuery('.ltn__utilize-cart-menu').removeClass("ltn__utilize-open");
//     jQuery('.ltn__utilize-cart-menu').removeClass("dontshow");
//     jQuery('.ltn__utilize-overlay').fadeOut();
//   },1000);
//   jQuery('.ltn__utilize-cart-menu').addClass("dontshow");
// }

// Shopify.addItem = function(variant_id, quantity, callback) {
//   var quantity = quantity || 1;
//   var params = {
//     type: 'POST',
//     url: '/cart/add.js',
//     data: 'quantity=' + quantity + '&id=' + variant_id,
//     dataType: 'json',
//     success: function(line_item) {
//       if ((typeof callback) === 'function') {
//         callback(line_item);
//       }
//       else {
//         Shopify.cartPopap(variant_id);
//         Shopify.onItemAdded(line_item);
//       }
//     },
//     error: function(XMLHttpRequest, textStatus) {
//       Shopify.onError(XMLHttpRequest, textStatus);
//     }
//   };
//   jQuery.ajax(params);
// };

// Shopify.addItemFromForm = function(form_id, variant_id,callback) {
//     var params = {
//       type: 'POST',
//       url: '/cart/add.js',
//       beforeSend: function(){
//         if(form_id == "add-item-qv") {
//           jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
//         }
//       },
//       data: jQuery('#' + form_id).serialize(),
//       dataType: 'json',
//       success: function(line_item) {
//         if ((typeof callback) === 'function') {
//           callback(line_item);
//         }
//         else {
//           if(form_id != "add-item-qv") {
//             Shopify.cartPopapForm(variant_id);
//           } else {
//           	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
//             jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
//             setTimeout(function(){
//               	jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
//             	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
//             }, 2000);
//           }
//           Shopify.onItemAdded(line_item);
//         }
//       },
//       error: function(XMLHttpRequest, textStatus) {
//         if(form_id != "add-item-qv") {
//           Shopify.onError(XMLHttpRequest, textStatus);
//         } else {
//           jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
//           jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
//           setTimeout(function(){
//             jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
//             jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
//           }, 2000);
//         }
//         Shopify.onItemAdded(line_item);
//       }
//     };
//     jQuery.ajax(params);
// };

// /* user functions */

// Shopify.addItemFromFormStart = function(form, product_id) {
//   Shopify.addItemFromForm(form, product_id);
// }

// Shopify.cartPopap = function(variant_id) {
//   	var image = jQuery('.'+variant_id+':first .popup_cart_image').attr("src");
//   	var title = jQuery('.'+variant_id+':first .popup_cart_title').text();
//   	jQuery('.popupimage').attr("src",''+image+'');
//   	jQuery('.productmsg').text(''+title+'');  
//   	jQuery('#modalAddToCart').modal("toggle");
// }
// Shopify.cartPopapForm = function(variant_id) {
//   	var image = jQuery('.product_variant_image').attr("src");
//   	var title = jQuery('#popup_cart_title').text();
//   	jQuery('.popupimage').attr("src",''+image+'');
// 	jQuery('.productmsg').text(''+title+'');
// 	jQuery('#modalAddToCart').modal("toggle");
// }

// Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
//   var formatMoney = window.money_format;
//   if ((typeof cart_cell_id) === 'string') {
//     var cart_cell = jQuery(cart_cell_id);
//     if (cart_cell.length) {

//       cart_cell.empty();

  
//       jQuery.each(cart, function(key, value) {
//         if (key === 'items') {
          
//           if (value.length == 1) {
//             jQuery(".cart-item-display").css({"display": "block"});
//             jQuery(".cart-empty-title").css({"display": "none"});
            
//             var table = jQuery(cart_cell_id);
//             jQuery.each(value, function(i, item) {
//               if(i > 19){
//                   return false;
//               }
//               jQuery('<div class="mini-cart-item clearfix"><div class="mini-cart-img"><a href="' + item.url + '"><img src="' + item.image + '" style="width: 100px;" alt=""></a><span onclick="Shopify.removeItem(' + item.variant_id + ')" class="mini-cart-item-delete"><i class="icon-cancel"></i></span></div><div class="mini-cart-info"><h6><a href="' + item.url + '">' + item.title + '</a></h6><span class="mini-cart-quantity">' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div></div>').appendTo(table);
//             });
//           }			
//           else if (value.length) {
//             jQuery(".cart-item-display").css({"display": "block"});
//             jQuery(".cart-empty-title").css({"display": "none"});
            
//             var table = jQuery(cart_cell_id);
//             jQuery.each(value, function(i, item) {
//               if(i > 19){
//                   return false;
//               }
//               jQuery('<div class="mini-cart-item clearfix"><div class="mini-cart-img"><a href="' + item.url + '"><img src="' + item.image + '" style="width: 100px;" alt=""></a><span onclick="Shopify.removeItem(' + item.variant_id + ')" class="mini-cart-item-delete"><i class="icon-cancel"></i></span></div><div class="mini-cart-info"><h6><a href="' + item.url + '">' + item.title + '</a></h6><span class="mini-cart-quantity">' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div></div>').appendTo(table);
//             });
//           }
//           else {
//             jQuery(".cart-item-display").css({"display": "none"});
//             jQuery(".cart-empty-title").css({"display": "block"});
//           }
//         }
//       });

      
//     }
//   }

//   changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
//   changeHtmlValue(".bigcounter", cart.item_count);

//   jQuery('.currency .active').trigger('click');
// }

// //Utils
// function changeHtmlValue (cell, value) {
//   var $cartLinkText = jQuery(cell);
//   $cartLinkText.html(value);
// };




/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.cart-item-loop');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
    var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function() {
    jQuery('.ltn__utilize-cart-menu').removeClass("ltn__utilize-open");
    jQuery('.ltn__utilize-cart-menu').removeClass("dontshow");
    jQuery('.ltn__utilize-overlay').fadeOut();
  },1000);
  jQuery('.ltn__utilize-cart-menu').addClass("dontshow");
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == "add-item-qv") {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
        }
      },
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if(form_id != "add-item-qv") {
            Shopify.cartPopapForm(variant_id);
          } else {
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
            jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
            setTimeout(function(){
              jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
              jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
            }, 2000);
          }
          Shopify.onItemAdded(line_item);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
          setTimeout(function(){
            jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  var image = jQuery('.'+variant_id+':first .popup_cart_image').attr("src");
  var title = jQuery('.'+variant_id+':first .popup_cart_title').text();
  jQuery('.popupimage').attr("src",''+image+'');
  jQuery('.productmsg').text(''+title+'');
  jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartPopapForm = function(variant_id) {
  var image = jQuery('.product_variant_image').attr("src");
  var title = jQuery('#popup_cart_title').text();
  jQuery('.popupimage').attr("src",''+image+'');
  jQuery('.productmsg').text(''+title+'');
  jQuery('#modalAddToCart').modal("toggle");
}

/*
 * Goodies progress helper
 * -----------------------
 * Uses cart.item_count exactly as Shopify reports it, so quantities count.
 * 5 or more total items = 10% OFF unlocked.
 */
Shopify.updateGoodiesProgress = function(cart) {
  var GOODIES_THRESHOLD = 5;

  var wrapper = jQuery('#hh-goodies-progress');
  if (!wrapper.length) {
    return;
  }

  var message = wrapper.find('#hh-goodies-message');
  var count = wrapper.find('#hh-goodies-count');
  var fill = wrapper.find('#hh-goodies-fill');
  var status = wrapper.find('#hh-goodies-status');
  var steps = wrapper.find('.hh-goodies-step');

  var itemCount = Number(cart && cart.item_count) || 0;

  if (itemCount <= 0) {
    wrapper.removeClass('is-visible is-unlocked');
    fill.css('width', '0%');
    count.text('0/5');
    steps.removeClass('is-active');
    return;
  }

  wrapper.addClass('is-visible');

  var completed = Math.min(itemCount, GOODIES_THRESHOLD);
  var remaining = Math.max(GOODIES_THRESHOLD - itemCount, 0);
  var percent = (completed / GOODIES_THRESHOLD) * 100;

  fill.css('width', percent + '%');
  count.text(completed + '/5');

  steps.each(function(index) {
    jQuery(this).toggleClass('is-active', index < completed);
  });

  if (itemCount >= GOODIES_THRESHOLD) {
    wrapper.addClass('is-unlocked');
    message.html('🎉 <strong>10% OFF unlocked!</strong>');
    status.text('You have 5+ Goodies in your cart. Your 10% OFF offer is unlocked.');
  } else {
    wrapper.removeClass('is-unlocked');
    message.html(
      'Add <strong>' + remaining + '</strong> more ' +
      (remaining === 1 ? 'Goodie' : 'Goodies') +
      ' to unlock <strong>10% OFF</strong>'
    );
    status.text('Buy 5 or more Goodies to unlock 10% OFF instantly.');
  }
};

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = window.money_format;
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function(key, value) {
        if (key === 'items') {

          if (value.length == 1) {
            jQuery(".cart-item-display").css({"display": "block"});
            jQuery(".cart-empty-title").css({"display": "none"});

            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                return false;
              }
              jQuery('<div class="mini-cart-item clearfix"><div class="mini-cart-img"><a href="' + item.url + '"><img src="' + item.image + '" style="width: 100px;" alt=""></a><span onclick="Shopify.removeItem(' + item.variant_id + ')" class="mini-cart-item-delete"><i class="icon-cancel"></i></span></div><div class="mini-cart-info"><h6><a href="' + item.url + '">' + item.title + '</a></h6><span class="mini-cart-quantity">' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div></div>').appendTo(table);
            });
          }
          else if (value.length) {
            jQuery(".cart-item-display").css({"display": "block"});
            jQuery(".cart-empty-title").css({"display": "none"});

            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                return false;
              }
              jQuery('<div class="mini-cart-item clearfix"><div class="mini-cart-img"><a href="' + item.url + '"><img src="' + item.image + '" style="width: 100px;" alt=""></a><span onclick="Shopify.removeItem(' + item.variant_id + ')" class="mini-cart-item-delete"><i class="icon-cancel"></i></span></div><div class="mini-cart-info"><h6><a href="' + item.url + '">' + item.title + '</a></h6><span class="mini-cart-quantity">' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div></div>').appendTo(table);
            });
          }
          else {
            jQuery(".cart-item-display").css({"display": "none"});
            jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });

      /*
       * Update the Goodies progress immediately after the cart contents
       * have been rebuilt. This is important because this cart API directly
       * empties and recreates .cart-item-loop.
       */
      Shopify.updateGoodiesProgress(cart);

      /*
       * Notify the other cart components immediately. The mini-cart listens
       * to this event and refreshes its progress/free-delivery bars.
       */
      jQuery(document.body).trigger('cart:updated', cart);

      try {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      } catch (e) {}
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);

  // Also update the progress if the DOM was already present.
  Shopify.updateGoodiesProgress(cart);
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};
